module.exports = __webpack_public_path__ + "static/img/avatar-bar.ef3b9c85.png";